<template>
  <div class="cat-header">
    <div class="row align-items-center cat-header-container">
      <div class="col-lg-8 col-md-12 col-xs-12 px-6">
        <template v-if="isUserChildrentList || !isParentUser">
        <div class="cat-icon">
          <img src="/static/images/img-main-sam.png" alt="sam" class="icon">
        </div>
        <div class="cat-body">
          <template v-if="!catComment">
            <span class="cat-title">{{ $t('common.sam_loading') }}</span>
          </template>
          <template v-else>
            <span class="cat-title">{{ $t('common.sam_hello')}}
              {{ isParentUser ?
                $t('common.sam_parent_greeting', { user: selectedChildName }) :
                $t('common.sam_student_greeting', { user: userName })
              }},</span><br>
            <span class="cat-description">
              {{ catComment() }}
            </span>
          </template>
        </div>
        </template>
      </div>
        <div class="col-lg-4 col-md-12 col-xs-12 p-14">
          <template v-if="isPremiumSchool">
            <span class="premium-school-text">{{ $t('common.premium_school') }}</span>
          </template>
          <template v-if="isParentUser">
          <div class="child-filter">
            <b-dropdown :text="selectedChildName" variant="variant" >
              <b-dropdown-item v-for="item in userChildrenList" :key="item.id"
                @click="selectChild(item)">
                {{ item.name }}
              </b-dropdown-item>
              <b-dropdown-item @click="openChildSettings()">+ {{ $t('common.child_add') }}</b-dropdown-item>
            </b-dropdown>
          </div>
          </template>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { CLASSTING_URL } from '@/config';
  import { random, isEmpty } from 'lodash';

  export default {
    name: 'cat-header',

    props: [
      'catDescription',
    ],

    data() {
      return {
        selectedChildName: this.$t('common.child_add'),
        selectedChildId: null,
        busy: false,
      };
    },

    computed: {
      ...mapGetters({
        currentUser: 'currentUser',
        isParentUser: 'isParentUser',
        getFirstSelectedChild: 'getFirstSelectedChild',
        selectedChild: 'getSelectedChild',
        userChildrenList: 'userChildrenList',
        childProficiencyHistory: 'getChildProficiencyHistory',
        childProficiencyRank: 'getChildProficiencyRank',
        isPremiumSchool: 'isPremiumSchool',
        notGrowthSubjectName: 'getNotGrowthSubjectName',
        growthSubjectName: 'getGrowthSubjectName',
        growthScore: 'getGrowthScore',
        activeAssignments: 'getActiveAssignments',
        randomComments: 'getRandomComments',
        catReturnVisitComment: 'getCatReturnVisitComment',
      }),

      assignmentLength() {
        return this.activeAssignments.length;
      },

      catRandomComment() {
        const maxNumber = this.randomComments.length - 1;
        return this.randomComments[random(0, maxNumber)];
      },

      userName() {
        return this.currentUser && this.currentUser.name;
      },

      isUserChildrentList() {
        return this.userChildrenList.length > 0;
      },
    },

    methods: {
      ...mapActions([
        'fetchUserRelationships',
        'setSelectedChild',
        'setSelectedChildId',
        'fetchChildProficiencyHistory',
        'fetchChildProficiencyRank',
        'setBusy',
      ]),

      catComment() {
        const growthScore = 20;
        const notGrowthScore = -20;

        if (this.getGrowthScore > growthScore) {
          return this.$t('common.sam_growth_comment', { subjectName: this.growthSubjectName, score: this.growthScore });
        }

        if (this.getNotGrowthScore < notGrowthScore) {
          return this.$t('common.sam_not_growth_comment', { subjectName: this.notGrowthSubjectName, score: this.growthScore });
        }

        if (!isEmpty(this.activeAssignments)) {
          return this.$t('common.sam_assignment_comment', { assignment: this.assignmentLength });
        }

        if (isEmpty(this.activeAssignments)) {
          return this.$t(this.catRandomComment);
        }

        return this.catReturnVisitComment;
      },

      selectChild(child) {
        this.setSelectedChild(child);
        this.selectedChildName = child.name;
        this.selectedChildId = child.id;
      },

      initParentView() {
        const filters = {};
        return this.fetchUserRelationships()
          .then(() => {
            if (!this.isUserChildrentList) {
              return true;
            }
            this.selectedChildName = (this.getFirstSelectedChild && this.getFirstSelectedChild.name);
            filters.child_id = this.getFirstSelectedChild && this.getFirstSelectedChild.id;
            return this.setSelectedChild(this.getFirstSelectedChild);
          })
          .then(() => {
            if (!this.isUserChildrentList) {
              return true;
            }

            return this.fetchChildProficiencyHistory(filters);
          })
          .then(() => {
            if (!this.isUserChildrentList) {
              return true;
            }

            return this.fetchChildProficiencyRank(filters);
          });
      },

      openChildSettings() {
        this.$ga.event({
          eventCategory: 'learning',
          eventAction: 'link_child',
        });
        const openedClassting = window.open(`${CLASSTING_URL}/settings/parent`);
        const delay = setInterval(() => {
          if (openedClassting.closed) {
            clearInterval(delay);
            this.initParentView();
          }
        }, 1000);
      },
    },

    beforeMount() {
      if (this.isParentUser) {
        this.setBusy(true);
        this.initParentView()
          .then(() => {
            this.setBusy(false);
          });
      }
    },

    watch: {
      selectedChildId(selected) {
        const filters = {
          child_id: selected,
        };

        if (!this.childProficiencyHistory[selected]) {
          this.fetchChildProficiencyHistory(filters);
        }

        if (!this.childProficiencyRank[selected]) {
          this.fetchChildProficiencyRank(filters);
        }
      },
    },

  };
</script>

<style lang="scss" scoped>
  .cat-header {
    background-color: #ffffff;
    border-bottom: 1px solid #e2e2e2;
    .cat-header-container {
      max-width: 946px;
      margin: 0 auto;

      .cat-title {
        color: #979797;
        font-size: 14px;
        font-weight: bold;

        @media (max-width: 375px) {
          font-size: 12px;
        }
      }

      .cat-body {
        display: inline-block;
        vertical-align: middle;

        .cat-description {
          font-size: 14px;
          font-weight: bold;
          padding: 2px;
          color: #000000;
          overflow: hidden; 
          text-overflow: ellipsis; 
          white-space: nowrap;

          @media (max-width: 375px) {
            font-size: 12px;
          }
        }
      }

      .cat-icon {
        display: inline-block;
        padding: 0px 14px 0px 14px;

        .icon {
          width: 64px;
          height: 64px;

          @media (max-width: 375px) {
            width: 54px;
            height: 54px;
          }
        }
      }
    }

    .premium-school-text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      text-align: right;
    }
  }
</style>


// WEBPACK FOOTER //
// CatHeader.vue?ca4531a4